import { isSdkSupported } from 'utilities/recordSdk/isSdkSupported';

export const isSupported = isSdkSupported;
